import { MenuButton as HeadlessMenuButton } from "@headlessui/react";
import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const BreadcrumbDropdownButton = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<"button"> & { truncate?: boolean }
>(function BreadcrumbItem({ className, truncate, ...props }, ref) {
  return (
    <HeadlessMenuButton
      ref={ref}
      className={classNames(
        "inline-flex gap-1 text-2xl font-bold items-center [&>svg]:size-6",
        className,
      )}
      {...props}
    />
  );
});
